import cn from 'classnames';
import { useEffect, useMemo, useState } from 'react';

import { LogoGrey } from '@webapp/common/assets/icons';
import { createFooterContainerStyle } from '@webapp/common/lib/ui';

import { SurveySection } from '../container';

import css from './footer.css';

export const SurveyFooter: VFC<{
    paddingLeft?: number;
    paddingRight?: number;
    className?: string;
    withIndicator?: boolean;
}> = ({ paddingLeft, paddingRight, className, withIndicator }) => {
    const [rootRef, setRootRef] = useState<HTMLElement | null>(null);
    const style = useMemo(() => createFooterContainerStyle(paddingLeft, paddingRight), [paddingRight, paddingLeft]);

    useEffect(() => {
        if (rootRef && !withIndicator) {
            const headerResizeObserver = new ResizeObserver(() => {
                document.body?.style?.setProperty(
                    '--survey-footer-size',
                    `calc(${rootRef.clientHeight}px + env(safe-area-inset-bottom, 0))`,
                );
            });

            headerResizeObserver.observe(rootRef);

            return () => headerResizeObserver.unobserve(rootRef);
        }
    }, [rootRef, withIndicator]);

    return (
        <footer ref={setRootRef} className={cn(css.footer, className)}>
            <div className={css.footerWrap}>
                <SurveySection className={css.container} style={style}>
                    <a
                        className={css.copy}
                        href='https://www.testograf.ru/?utm_source=testograf&utm_campaign=footer'
                        rel='noopener noreferrer'
                        target='_blank'
                    >
                        <LogoGrey className={css.logo} />
                    </a>
                </SurveySection>
            </div>
        </footer>
    );
};
SurveyFooter.displayName = 'SurveyFooter';
